import React, { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { useIntl } from 'react-intl'
import { FooterLink } from '..'
import { Link } from 'gatsby'
import { Text } from '../../../atoms/text'
import { Button } from '../../../atoms/button'

export interface LegalAreaProps {
  links: FooterLink[]
}

const LegalArea: FunctionComponent<LegalAreaProps> = ({ links }) => {
  const intl = useIntl()
  return (
    <Wrapper>
      <ul>
        {links.map((link, index) => {
          return (
            <li>
              <StyledLink
                themeOverride="background_is_lighter"
                variant="ghost"
                key={`legal-link-${link.title}-${index}`}
                as={link.openInNewTab ? 'a' : Link}
                {...(link.openInNewTab ? { href: `${link.link}` } : { to: `${link.link}` })}
                target={link.openInNewTab ? '_blank' : '_self'}
                rel={link.openInNewTab ? 'noopener noreferrer' : undefined}
              >
                {link.title}
              </StyledLink>
            </li>
          )
        })}
        <StyledCookieButton key={intl.locale}>
          <StyledLink themeOverride="background_is_lighter" variant="ghost" prefetch={false} href="#" id="ot-sdk-btn" className="ot-sdk-show-settings">
            {`${intl.formatMessage({id: 'footer.cookies'})}`}
          </StyledLink>
        </StyledCookieButton>
      </ul>
      <CopyRightText fontStyle="label-m">{`${intl.formatMessage({
        id: 'footer.copyright',
      })} ${new Date().getFullYear()}`}</CopyRightText>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > ul {
    display: flex;
    list-style: none;
  }

  & > ul > li:first-child > a {
    @media (min-width: 1280px) {
      padding-left: 0;
    }
  }

  @media (max-width: 1279px) {
    padding-top: 2.5rem;
    flex-direction: column;
    gap: 2rem;

    & > ul {
      display: flex;
      place-content: center;
      flex-wrap: wrap;
    }

    & > ul > li > a {
      padding-block: 0.75rem;
    }
  }
`

const StyledLink = styled(Button)`
  span {
    font-size: 10px;
  }
  text-transform: none;
`

const StyledCookieButton = styled.li`
  button {
    background-color: transparent !important;
    color: var(--beige-100) !important;
    padding-block: 0.75rem !important;
    font-size: 10px !important;
    line-height: var(--label-s-lineHeight) !important;
    letter-spacing: var(--label-s-letterSpacing) !important;
    font-weight: 400 !important;
  }

  button:hover {
    background-color: transparent !important;
    color: var(--beige-100) !important;
  }

  button:active {
    background-color: transparent !important;
    color: var(--beige-100) !important;
    border: none !important;
  }

  @media (min-width: 1280px) {
    button {
      padding: 20px 22px !important;
    }
  }
`;

const CopyRightText = styled(Text)`
  color: var(--beige-100);
`

export default LegalArea
